@if (preview(); as preview) {
	<ng-template #userTemplate><nz-icon nzType="user" /></ng-template>
	<ng-template #usersTemplate><nz-icon nzType="team" /></ng-template>
	<ng-template #courseWorkTemplate><nz-icon nzType="read" /></ng-template>
	<ng-template #locationTemplate><nz-icon nzType="home" /></ng-template>
	<ng-template #errorTemplate><nz-icon nzType="stop" class="red" /></ng-template>
	<ng-template #successTemplate><nz-icon nzType="check-circle" class="green" /></ng-template>

	@if (steps(); as steps) {
		<div class="stats-box">
			@if (steps.includes(SetupWizardSteps.USERS)) {
				<!-- Users Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.users.length | number)!"
					nzTitle="Existing Users"
					[nzPrefix]="userTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.usersUpserts | number)!"
					nzTitle="Users to Create or Update"
					[nzPrefix]="userTemplate"
				/>

				<!-- Users To Sections Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.usersToSections.length | number)!"
					nzTitle="Existing User To Section Links"
					[nzPrefix]="userTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.usersToSectionsUpserts | number)!"
					nzTitle="User To Section Links to Create or Update"
					[nzPrefix]="userTemplate"
				/>
			}

			<!-- Locations Stats -->
			@if (steps.includes(SetupWizardSteps.LOCATIONS)) {
				<nz-statistic
					[nzValue]="(preview.payload.locations.length | number)!"
					nzTitle="Existing Locations"
					[nzPrefix]="locationTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.locationsCreates | number)!"
					nzTitle="New Locations"
					[nzPrefix]="locationTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.locationsUpdates | number)!"
					nzTitle="Locations to Update"
					[nzPrefix]="locationTemplate"
				/>

				<!-- School Admin to Location Links Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.schoolAdminsToLocations.length | number)!"
					nzTitle="Existing School Admin to Location Links"
					[nzPrefix]="locationTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.schoolAdminsToLocationsUpserts | number)!"
					nzTitle="School Admin to Location Links to Create or Update"
					[nzPrefix]="locationTemplate"
				/>
			}

			<!-- Sections Stats -->
			@if (steps.includes(SetupWizardSteps.SECTIONS)) {
				<nz-statistic
					[nzValue]="(preview.payload.sections.length | number)!"
					nzTitle="Existing Sections"
					[nzPrefix]="usersTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.sectionsCreates | number)!"
					nzTitle="New Sections"
					[nzPrefix]="usersTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.sectionsUpdates | number)!"
					nzTitle="Sections to Update"
					[nzPrefix]="usersTemplate"
				/>
			}

			<!-- Course Stats -->
			@if (steps.includes(SetupWizardSteps.COURSE_WORK)) {
				<nz-statistic
					[nzValue]="(preview.payload.courses.length | number)!"
					nzTitle="Existing Courses"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.coursesCreates | number)!"
					nzTitle="New Courses"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.coursesUpdates | number)!"
					nzTitle="Courses to Update"
					[nzPrefix]="courseWorkTemplate"
				/>

				<!-- Unit Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.units.length | number)!"
					nzTitle="Existing Units"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.unitsCreates | number)!"
					nzTitle="New Units"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.unitsUpdates | number)!"
					nzTitle="Units to Update"
					[nzPrefix]="courseWorkTemplate"
				/>

				<!-- Lesson Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.lessons.length | number)!"
					nzTitle="Existing Lessons"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.lessonsCreates | number)!"
					nzTitle="New Lessons"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.lessonsUpdates | number)!"
					nzTitle="Lessons to Update"
					[nzPrefix]="courseWorkTemplate"
				/>

				<!-- Activity Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.activities.length | number)!"
					nzTitle="Existing Activities"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.activitiesCreates | number)!"
					nzTitle="New Activities"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.activitiesUpdates | number)!"
					nzTitle="Activities to Update"
					[nzPrefix]="courseWorkTemplate"
				/>

				<!-- Content Stats -->
				<nz-statistic
					[nzValue]="(preview.payload.contents.length | number)!"
					nzTitle="Existing Contents"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.contentsCreates | number)!"
					nzTitle="New Contents"
					[nzPrefix]="courseWorkTemplate"
				/>
				<nz-statistic
					[nzValue]="(preview.stats.contentsUpdates | number)!"
					nzTitle="Contents to Update"
					[nzPrefix]="courseWorkTemplate"
				/>
			}
		</div>
	}
}
